// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component } from '@angular/core';
import { BaseWidget } from 'gridstack/dist/angular';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HeaderService } from '../../../header.service';
import { D3eService } from '../../../../services/d3e-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { withLoading } from '../../../../shared/misc';
import { IEndpointTotals } from '../../../../types/endpoints';

@UntilDestroy({checkProperties: true})
@Component({
    selector: 'app-endpoints-total',
    templateUrl: './endpoints-total.component.html',
    styleUrls: ['./endpoints-total.component.scss', '../dynamic-dashboard.common.scss'],
    standalone: false
})
export class EndpointsTotalComponent extends BaseWidget {
  totalEndpoints$?: Observable<IEndpointTotals> = new Subject<IEndpointTotals>();
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private headerService: HeaderService,
              private d3eService: D3eService) {
    super();

    this.totalEndpoints$ = this.headerService.orgSelectedChanged
      .pipe(
        switchMap((selectedOrgId) => {
            return this.d3eService.getEndpointsRelativeChanges(selectedOrgId.toLowerCase() === 'all' ? '' : selectedOrgId).pipe(
                withLoading(isLoading => this.loading$.next(isLoading))
            );
        }),
        catchError(error => {
          this.loading$.next(false);
          // TODO: pass error to child? so it can show error appropriately?
          //  Also, show a snack bar with error?
          return throwError(error);
        }),
        untilDestroyed(this)
      );
  }
}
